import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import React, { MouseEvent, useState } from 'react';

import ActionDialog from '~components/ActionDialog';
import OberonCard from '~components/OberonCard';

import { DiallerGroupSipQueue } from '../../../domain';

interface QueueCardProps {
  queue: DiallerGroupSipQueue;
  onEdit: () => void;
  onDelete: () => void;
}

const DiallerGroupQueueCard = ({ queue, onEdit, onDelete }: QueueCardProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState<boolean>(false);

  const handleMenuOpen = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const triggerEdit = () => {
    setAnchorEl(null);
    onEdit();
  };

  const triggerDelete = () => {
    onDelete();
    setDeleteConfirmModalOpen(false);
  };

  const handleDeleteConfirmationOpen = () => {
    setAnchorEl(null);
    setDeleteConfirmModalOpen(true);
  };

  const handleDeleteConfirmationClose = () => {
    setDeleteConfirmModalOpen(false);
  };

  return (
    <>
      <OberonCard
        reverseTitles
        titleFontWeight={700}
        title={queue.queueName}
        subHeader={
          <>
            <Box sx={{ mb: 1 }}>ID: {queue.queueID}</Box>
          </>
        }
        action={
          <>
            <IconButton aria-controls='group-queue-menu' aria-haspopup='true' onClick={handleMenuOpen}>
              <MoreHorizIcon />
            </IconButton>

            <Menu
              id='group-queue-menu'
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}>
              <MenuItem onClick={triggerEdit}>Edit</MenuItem>
              <MenuItem onClick={handleDeleteConfirmationOpen}>Delete</MenuItem>
            </Menu>
          </>
        }
        footer={
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <Typography
              variant='caption'
              color='textSecondary'
              sx={{
                marginRight: 1,
              }}>
              Priority: {queue.priority}
            </Typography>
            <Typography
              variant='caption'
              color='textSecondary'
              sx={{
                marginLeft: 1,
              }}>
              Delay: {queue.delay}s
            </Typography>
          </Box>
        }
      />
      <ActionDialog
        open={deleteConfirmModalOpen}
        title='Are you sure you want to do this?'
        content={`You are about to remove queue ${queue.queueName} from this group.`}
        onClose={handleDeleteConfirmationClose}
        onAccept={triggerDelete}
        primaryActionTitle='Delete'
      />
    </>
  );
};

export default DiallerGroupQueueCard;
